import { getRequestWithAuth, postRequestWithAuth } from "../api";

export type MetabaseConnectionData = {
  metabaseUrl: string;
  apiKey: string;
};

export type MetabaseImportJobData = MetabaseConnectionData & {
  autoMigrate: boolean;
};

export type MetabaseMigrationData = {
  jobId: string;
  selectedItems: any[];
};

export const testConnection = async (data: MetabaseConnectionData) => {
  const response = await postRequestWithAuth(
    "/api/v1/metabase/test-connection",
    {
      metabase_url: data.metabaseUrl,
      api_key: data.apiKey,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  return response;
};

export const startImport = async (data: MetabaseImportJobData) => {
  const response = await postRequestWithAuth(
    "/api/v1/metabase/import/start",
    {
      metabase_url: data.metabaseUrl,
      api_key: data.apiKey,
      auto_migrate: data.autoMigrate,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  return response;
};

export const pollImportStatus = async (jobId: string) => {
  const response = await getRequestWithAuth(
    `/api/v1/metabase/import/${jobId}/status`
  );
  return response;
};

export const loadPreviewData = async (jobId: string) => {
  const response = await getRequestWithAuth(
    `/api/v1/metabase/import/${jobId}/preview`
  );
  return response;
};

export const executeMigration = async (data: MetabaseMigrationData) => {
  const response = await postRequestWithAuth(
    `/api/v1/metabase/import/${data.jobId}/execute`,
    {
      selected_items: data.selectedItems.filter((item) => item.will_import),
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  return response;
};
